import React from 'react';

import './skills.css';

const skillsData = [
    
    { name: 'HTML', img: 'https://cdn.worldvectorlogo.com/logos/html-1.svg' },
    { name: 'CSS', img: 'https://cdn.worldvectorlogo.com/logos/css-3.svg' },
    { name: 'JavaScript', img: 'https://cdn.worldvectorlogo.com/logos/javascript-1.svg' },
    { name: 'React', img: 'https://cdn.worldvectorlogo.com/logos/react-2.svg' },
    { name: 'Figma', img: 'https://cdn.worldvectorlogo.com/logos/figma-icon.svg' },
    { name: 'Photoshop', img: 'https://cdn.worldvectorlogo.com/logos/adobe-photoshop-2.svg' }
  ];
  
  const Skills = () => {
    return (
      <div className="skills-container">

        <div className="skills-list">
          {skillsData.map((skill, index) => (
            <div key={index} className="skill-item">
              <img src={skill.img} alt={`${skill.name} logo`} className="skill-icon" />
              <span>{skill.name}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };
export default Skills;
